import React from "react";
import "./MicWave.css";

export default function MicWave({ animated }) {
  return (
    <div className="mic-wave">
      {/* Les barres, affichées seulement si animated = true */}
      <div
        className="bars-container"
        style={{ display: animated ? "flex" : "none" }}
      >
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      {/* Micro + pied */}
      <svg
        className="mic-icon"
        viewBox="0 0 24 24"
        fill="currentColor"
        width="48px"
        height="48px"
      >
        <path d="
          M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3zm5 9
          a5 5 0 0 1-10 0H5a7 7 0 0 0 14 0h-2z
          M10 16h4v2h2v2H8v-2h2z
        " />
      </svg>
    </div>
  );
}
